import store from '../store/store';

export const loginGuard = (to, from, next) => {
    if (store.getters.accessToken) {
        next({ name: 'enterprise-list' });
    } else {
        next();
    }
};